/* global __SERVER__ */

import React, { PureComponent } from 'react';
import { asyncConnect } from 'redux-connect';

import authService from '../../state/services/auth';
import { fetchEvents } from '../../state/actions';
import { trackPageVisit } from '../../utils/tracking';
import { getGeoLocation, getCountryViewport } from '../../utils/geoLocation';
import { getLocalStorage } from '../../utils';
import { recentEventVisits } from '../../utils/localStorage';

import Homepage from '../../components/Homepage';

const getTrendingQuery = () => ({
  resultsPerPage: 9,
  sort: 'trending',
});

class HomepageContainer extends PureComponent {
  state = {
    geoLocation: null,
    countryCode: undefined,
    recentEvents: undefined,
  }

  async componentDidMount() {
    trackPageVisit('Homepage');
    await this.setLocation();
    this.setRecentEvents();
  }

  async setLocation() {
    const geoLocation = await getGeoLocation();
    const countryViewport = getCountryViewport();
    this.setState({ geoLocation, countryViewport });
  }

  setRecentEvents() {
    this.setState({
      recentEvents: JSON.parse(getLocalStorage(recentEventVisits.key)),
    });
  }

  render() {
    const hasUserCookie = authService.hasUserCookie();
    return (
      <Homepage
        hasUserCookie={hasUserCookie}
        trendingQuery={getTrendingQuery()}
        recentEventViews={this.state.recentEvents}
        {...this.props}
        geoLocation={this.state.geoLocation}
        countryCode={this.state.countryCode}
      />
    );
  }
}

const asyncPromises = [{
  promise: ({ store: { dispatch } }) =>
    (__SERVER__
      ? dispatch(fetchEvents(getTrendingQuery()))
      : Promise.resolve()),
}];

// Wrap in [redux-connect](https://github.com/makeomatic/redux-connect)
const HomepageContainerWithAsync = asyncConnect(asyncPromises)(HomepageContainer);

export default HomepageContainerWithAsync;



// WEBPACK FOOTER //
// ./app/src/containers/Homepage/index.jsx